import { getCharge, getYuE } from '@/api/wenjuan/reward'
import { leavePayment, paymentInfo, paymentType } from '@/assets/js/localStorageKeys'
import { checkIsOk, getRechargeResult, setPayFlag } from '@/assets/js/pay'
import { getAllUrl } from '@/mixins/getRechargeUrl'

export default {
  methods: {
    chargeHandlerOld(info, callback) {
      let { orderNo, charge } = info
      if (charge > 0 && charge < 1) {
        charge = 1
        info.charge = 1
      }
      window.localStorage.removeItem(leavePayment)
      getCharge({ orderNo, charge }).then(res => {
        let d = res.data.data
        this.paymentInfo.innerId = d.innerId
        this.paymentInfo.qrcode = d.qrcode
        window.localStorage.setItem(paymentInfo, JSON.stringify(this.paymentInfo))
        this.loopWebLeave()
        let payUrl = ''
        getAllUrl.call(this)
        this._payment()
        callback && callback()
        // this.resultPay = true
      })
    },
    _payment() {
      getRechargeResult({
        innerId: this.paymentInfo.innerId,
        surveyId: this.surveyId,
        balance: this.paymentInfo.balance,
        success: () => {
          window.localStorage.setItem(paymentType, JSON.stringify({ type: 'success' }))
          this.clearLoopWeb()
        }
      })
        .then(res => {
          this.rechargeSuccess && this.rechargeSuccess()
        })
        .catch(err => {
          this.handelPaymentError && this.handelPaymentError()
        })
      /*      return
            this.flag = true
            const msgOkArr = ['成功']
            const msgErrArr = ['转入退款', '已关闭', '已撤销', '支付失败']
            const msgMap = []
            msgOkArr.forEach(msg => {
              msgMap.push({
                type: 'success',
                msg
              })
            })
            msgErrArr.forEach(msg => {
              msgMap.push({
                type: 'error',
                msg
              })
            })
            const result = () => {
              if (this.flag) {
                czResult({ innerId: this.paymentInfo.innerId, surveyId: this.surveyId }).then(res => {
                  // 确保上一次请求完成 再次请求
                  let msg = res.data.data.chargeResult
                  let findObj = msgMap.find(item => item.msg === msg)
                  if (findObj) {
                    this.flag = false
                    if (findObj.type !== 'success') {
                      return Promise.resolve(findObj)
                    }
                    window.localStorage.setItem(paymentType, JSON.stringify({ type: findObj.type }))
                    this.clearLoopWeb()
                    return Promise.resolve(this.paymentInfo.balance)
                  }
                  setTimeout(() => {
                    result()
                  }, 1000)
                  return Promise.reject('error')
                }).then(num => {
                  if (typeof num === 'object') {
                    this.handelPaymentError()
                    return
                  }
                  let f = true
                  const load = transformLoadingFunction('正在获取结果')
                  const fn = () => {
                    if (!f) return
                    getYuE().then(res => {
                      // num == res.data.data ? fn() : this.onClickConfirmPayment()
                      if (num == res.data.data) {
                        fn()
                      } else {
                        this.rechargeSuccess && this.rechargeSuccess()
                        load.close()
                      }
                    })
                  }
                  fn()
                  setTimeout(() => {
                    f = false
                  }, 1000 * 100)
                })
              }
            }
            this.timers = setTimeout(() => {
              if (!this.flag) return
              // this.$message.error("充值失败！")
              this.handelPaymentError()
              this.flag = false
            }, 1000 * 120)
            result()*/
    },
    loopWebLeave() {
      this.leaveTimer = setInterval(() => {
        let obj = JSON.parse(window.localStorage.getItem(leavePayment)) || {}
        if (obj.isLeave) {
          // this.onClickSuccess()
          clearInterval(this.leaveTimer)
          if (getRechargeResult.flag) {
            this.onClickSuccess && this.onClickSuccess()
          }
          this.leaveTimer = null
          window.localStorage.removeItem(leavePayment)
        }
      }, 1000)
    },
    clearLoopWeb() {
      // clearInterval(this.leaveTimer)
      this.leaveTimer = null
      window.localStorage.removeItem(leavePayment)
    },

    // 新方式 old 是之前处理方式

    chargeHandler(info, callback) {
      let { orderNo, charge } = info
      if (charge > 0 && charge < 1) {
        info.charge = 1
      }
      getAllUrl.call(this)
      callback && callback()
      this.checkIsOk()
    },
    // 是否充值成功
    checkIsOk(maxTime = 120) {
      const expire = Date.now() + maxTime * 1000
      getYuE().then(res => {
        setPayFlag(true)
        checkIsOk(
          expire,
          res.data.data,
          newBalance => {
            console.log('充值成功')
            this.rechargeSuccess && this.rechargeSuccess()
          },
          err => {
            this.handelPaymentError && this.handelPaymentError()
          }
        )
      })
    }
  }
}
